import { render, staticRenderFns } from "./CrossSell.vue?vue&type=template&id=dc97b2b8&scoped=true"
import script from "./CrossSell.vue?vue&type=script&lang=js"
export * from "./CrossSell.vue?vue&type=script&lang=js"
import style0 from "./CrossSell.vue?vue&type=style&index=0&id=dc97b2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc97b2b8",
  null
  
)

export default component.exports